<template>
    <div class="app-consumption">
        <mu-row justify-content="start" align-items="end" class="title">
            <mu-col span="12" sm="12" md="9" lg="9" xl="9">
                <mu-flex justify-content="start" align-items="center">
                    <font-awesome-icon icon="user-tie" class="small" />
                    <mu-title type="h2" color="primary" textStrong="900">Acompanhamento de Clientes</mu-title>
                </mu-flex>
            </mu-col>
            <mu-col span="12" sm="12" md="3" lg="3" xl="3">
                <mu-button color="primary" round small class="update-float" @click="consumptionLoad()"><font-awesome-icon icon="sync" /> Atualizar</mu-button>
            </mu-col>
        </mu-row>
        <div class="consumption">
            <div class="dialog-box-search">
                <table class="mu-table-search">
                    <tbody>
                        <tr>
                            <td>
                                <label>Busca pelo nome</label>
                                <input type="text" v-model="consumption.search.term">
                            </td>
                            <td>
                                <label>Assinatura</label>
                                <select v-model="consumption.search.signature_type">
                                    <option value="">Todos</option>
                                    <option value="P">Pré Pago</option>
                                    <option value="C">Pós Pago</option>
                                    <option value="T">Teste</option>
                                </select>
                            </td>
                            <td>
                                <label>Tipo</label>
                                <select v-model="consumption.search.custom_type">
                                    <option value="">Todos</option>
                                    <option value="R">Revendas</option>
                                    <option value="C">Clientes</option>
                                </select>
                            </td>
                            <td>
                                <label>Status</label>
                                <select v-model="consumption.search.status">
                                    <option value="">Todos</option>
                                    <option value="A">Ativos</option>
                                    <option value="I">Inativos</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mu-paper :z-depth="1">
                <div class="scroll">

                    <table v-if="!consumption.loading" class="mu-table-custom">
                        <thead>
                            <tr>
                                <th>Cliente ({{ consumptionList.length }})</th>
                                <th>Assinatura</th>
                                <th>Tipo</th>
                                <th>Status</th>
                                <th>Serviço</th>
                                <th class="text-center">
                                    <a href="javascript:;" @click="sortBy('balance', consumption.sort.order == 'desc' ? 'asc' : 'desc')"><font-awesome-icon v-if="consumption.sort.name == 'balance'" :icon="consumption.sort.order == 'desc' ? 'arrow-down' : 'arrow-up'" /> Saldo *</a>
                                </th>
                                <th class="text-center">
                                    <a href="javascript:;" @click="sortBy('send', consumption.sort.order == 'desc' ? 'asc' : 'desc')"><font-awesome-icon v-if="consumption.sort.name == 'send'" :icon="consumption.sort.order == 'desc' ? 'arrow-down' : 'arrow-up'" /> Envios/Recebimentos **</a>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, key) in consumptionList" :key="key" v-bind:class="{ 'inactive' : item.status == 'I', 'active' : item.status == 'A' }">
                                <td>
                                    <div class="opacity">
                                        <strong class="nickname"><router-link :to="{ name: 'app.settings.clients.edit', params: { id: item.id } }">{{ item.nick_name }}</router-link></strong><br>
                                        <span class="socialname">{{ item.social_name }}</span>
                                    </div>
                                </td>
                                <td><div class="opacity">{{ getSignatureType(item.signature_type) }}</div></td>
                                <td><div class="opacity">{{ getCustomType(item.custom_type) }}</div></td>
                                <td>
                                    <div class="opacity">
                                        <mu-badge content="Inativo" v-if="item.status != 'A'"></mu-badge>
                                        <mu-badge content="Ativo" v-if="item.status == 'A'" color="success"></mu-badge>
                                    </div>
                                </td>
                                <td><div class="opacity">{{ item.service_name }}</div></td>
                                <td class="text-center">
                                    <div class="opacity">
                                        <span class="balance" v-if="item.signature_type !== 'C'">
                                            {{ item.balance }}
                                        </span>
                                        <span v-else>-</span>
                                    </div>
                                </td>
                                <td class="text-center"><div class="opacity">{{ item.send }}</div></td>
                            </tr>
                        </tbody>
                    </table>

                    <mu-loading v-if="consumption.loading" text="Aguarde... Carregando lista de clientes..."></mu-loading>

                    <div v-if="!consumption.loading && consumptionList.length == 0" class="clients-empty">
                        <div v-if="consumption.search.term != ''">
                            <font-awesome-icon icon="search" />
                            <mu-title type="h3" textStrong="100" color="primary">Nenhum cliente encontrado para <u>{{ consumption.search.term }}</u>!</mu-title>
                        </div>
                        <div v-else>
                            <font-awesome-icon icon="building" />
                            <mu-title type="h3" textStrong="100" color="primary">Nenhum cliente cadastrado!</mu-title>
                            <mu-button color="primary" small round :to="{ name: 'app.settings.clients.create' }">Cadastrar</mu-button>
                        </div>
                    </div>

                </div>
                <div class="legend">
                    <p>* Atualização do saldo é em tempo real. (Pré Pago e Teste)</p>
                    <p>** Total de envios e recebimentos do mês atual.</p>
                    <p>** A soma não consta os envios e recebimentos do dia de hoje.</p>
                    <p v-if="isZiad()">** Revendas tem a soma unificada.</p>
                </div>
            </mu-paper>
        </div>
    </div>
</template>

<script>
    import ConsumptionServices from '@/services/dashboards/consumption'

    export default {
        name: 'app-consumption',

        // ╔═╗╦═╗╔═╗╔═╗╔═╗
        // ╠═╝╠╦╝║ ║╠═╝╚═╗
        // ╩  ╩╚═╚═╝╩  ╚═╝

        props: ['type'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                consumption: {
                    search: {
                        term: '',
                        signature_type: '',
                        custom_type: '',
                        status: ''
                    },
                    status: false,
                    loading: false,
                    sort: {
                        name: '',
                        order: 'desc'
                    },
                    columns: [
                        { title: 'Cliente', name: 'nick_name', sortable: true },
                        { title: 'Assinatura', name: 'signature_type' },
                        { title: 'Tipo', name: 'custom_type' },
                        { title: 'Status', name: 'status' },
                        { title: 'Serviço', name: 'service_name' },
                        { title: 'Saldo *', name: 'balance', sortable: true },
                        { title: 'Envios/Recebimentos **', name: 'send', sortable: true }
                    ],
                    list: []
                }
            }
        },

        computed: {
            consumptionList () {
                let result = this.consumption.list
                if (this.consumption.search.signature_type !== '') {
                    result = result.filter((item) => {
                        return item.signature_type === this.consumption.search.signature_type
                    })
                }
                if (this.consumption.search.custom_type !== '') {
                    result = result.filter((item) => {
                        return item.custom_type === this.consumption.search.custom_type
                    })
                }
                if (this.consumption.search.status !== '') {
                    result = result.filter((item) => {
                        return item.status === this.consumption.search.status
                    })
                }
                return result.filter((item) => {
                    return item.nick_name.toLowerCase().includes(this.consumption.search.term.toLowerCase()) || item.social_name.toLowerCase().includes(this.consumption.search.term.toLowerCase())
                })
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        created () {
            this.consumptionLoad()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            getCustomType (type) {
                switch (type) {
                case 'R':
                    return 'Revenda'
                case 'C':
                    return 'Cliente'
                default:
                    return '-'
                }
            },

            getSignatureType (type) {
                switch (type) {
                case 'C':
                    return 'Pós Pago'
                case 'T':
                    return 'Teste'
                case 'P':
                    return 'Pré Pago'
                default:
                    return '-'
                }
            },

            sortBy (name, order) {
                this.consumption.sort.name = name
                this.consumption.sort.order = order
                this.consumption.list = this.consumption.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name])
            },

            /**
             * Carrega a listagem de consumação de seus clientes
             */
            async consumptionLoad () {
                try {
                    this.consumption.loading = true

                    let result = await ConsumptionServices.findBy({
                        by: this.type
                    })

                    if (result && result.status) {
                        this.consumption.list = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar o consumo.')
                } finally {
                    this.consumption.loading = false
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .app-consumption

        .dialog-box-search

            border-radius 4px
            margin 15px 0
            padding 10px
            background lighten($grey, 60%)
            color $grey

            svg
                color $grey
                font-size 20px
                margin 0 15px

            label
                font-size 12px
                font-weight bold

            input, select
                color $grey
                background lighten($grey, 90%)
                padding 6px 0
                font-size 12px
                width 100%
                border 1px #ddd solid

            input
                text-indent 10px

        table.mu-table-custom
            width 100%
            text-align left
            border-spacing 0
            th
                background lighten($grey, 70%)
                color $grey
                a
                    color $grey
            td, th
                padding 5px 8px
                border-bottom 1px lighten($grey, 60%) solid
            tr:hover
                background lighten($grey, 85%)
            .active
                .nickname
                    a
                        color $primary
                        text-decoration underline
                .socialname
                    color $gray
                    font-size 11px
                .balance
                    color $green
                    font-size 16px
                    font-weight 900
            .inactive
                .opacity
                    opacity 0.3

        .update-float
            float right
            margin-top 15px
            font-size 11px
            padding-left 15px
            padding-right 15px

            svg
                margin-right 6px

        .title
            svg.small
                color $primary
                margin 4px 5px 0 0
                font-size 18px

        .consumption
            .mu-paper
                margin-top 5px
                h4
                    font-size 14px
                    margin 0
                    padding 10px
                    color darken($grey, 30%)
                .scroll
                    overflow-y scroll
                    height 350px
                    .text-center
                        text-align center
            .legend
                font-size 11px
                padding 10px
                background lighten($grey, 70%)
                color lighten($color-gray-dark, 30%)
                p
                    margin 0

            .clients-empty
                padding-top 30px
                text-align center
                h3
                    margin-bottom 20px
                svg
                    font-size 30px
                    color $primary
                .mu-button
                    padding-left 10px
                    padding-right 10px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .app-dashboard

            .column-first
                padding-right 20px

</style>
